import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useAuth } from '@contexts'
import { useToast } from '@contexts/ToastContext'

/**
 * Componente funcional sem UI que monitora a URL em busca de tokens de verificação de e-mail.
 * Quando um token é encontrado, dispara a verificação e limpa a URL.
 */
const EmailVerificationHandler = () => {
  const [searchParams] = useSearchParams()
  const { verifyEmail, isEmailVerified, loading } = useAuth()
  const { showToast } = useToast()
  const processing = useRef(false)

  useEffect(() => {
    // Ignora se for a nova rota de validação dedicada
    if (window.location.pathname === '/validar-email') return

    // Se ainda estiver carregando os dados do usuário, aguarda para saber o status real de verificação
    if (loading) return

    const token = searchParams.get('verificationToken')
    
    if (token && !processing.current) {
      processing.current = true
      
      const performVerification = async () => {
        try {
          // Se o usuário já estiver verificado, avisa e não faz a requisição
          if (isEmailVerified) {
            showToast('Usuário já verificado', 'info')
          } else {
            await verifyEmail(token)
          }
        } finally {
          // Remove o token da URL de forma limpa (incluindo o ?)
          const url = new URL(window.location.href);
          url.searchParams.delete('verificationToken');
          const newUrl = url.pathname + url.searchParams.toString() + url.hash;
          window.history.replaceState({}, '', newUrl || '/');
          
          processing.current = false;
        }
      }

      performVerification()
    }
  }, [searchParams, verifyEmail, isEmailVerified, loading, showToast])

  return null
}

export default EmailVerificationHandler
